import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Ban } from "lucide-react";

interface Props {
  text?: string;
}

export const NoData = ({ text }: Props) => {
  return (
    <Flex
      data-testid="no-data"
      alignItems="center"
      justifyContent="center"
      css={{
        "@media (max-width: 1350px) and (min-width: 1272px)": {
          maxWidth: "900px",
        },
        "@media (max-width: 1414px) and (min-width: 1351px)": {
          maxWidth: "1000px",
        },
        "@media (max-width: 1590px) and (min-width: 1415px)": {
          maxWidth: "1200px",
        },
        "@media (max-width: 1696px) and (min-width: 1591px)": {
          maxWidth: "1300px",
        },
        "@media (max-width: 1900px)": {
          maxWidth: "1500px",
        },
      }}
      height={{ lg: "300px", xl: "300px", "2xl": "475px" }}
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
    >
      <Flex flexDir="column" alignItems="center" gap="15px">
        <Ban size="100px" color={AppColors.GRAY_ICON} />
        <Text fontSize="16px" fontWeight={600} color={AppColors.GRAY_TEXT}>
          {text ?? "No hay datos disponibles"}
        </Text>
      </Flex>
    </Flex>
  );
};
